// extracted by mini-css-extract-plugin
module.exports = {"AddPopupPage":"ModeratePopupsPage_AddPopupPage__3Xk0s"};